<template>
  <div class="service-page">
    <ServicePageHeader
      icon="fas fa-hands-helping"
      title="Guidance & Counseling"
      subtitle="Professional support for your personal, academic, and career growth"
      show-back-link
    />

    <!-- Main Content -->
    <main class="service-content">
      <div class="container">
        <!-- Overview -->
        <section class="content-section">
          <h2>
            <i class="fas fa-info-circle section-icon" />
            Overview
          </h2>
          <p>
            The Guidance and Counseling Office provides comprehensive support services to help students
            navigate their academic journey, personal challenges, and career decisions. Our licensed
            counselors are dedicated to fostering student well-being and success.
          </p>
        </section>

        <!-- Services Offered -->
        <section class="content-section">
          <h2>
            <i class="fas fa-list-check section-icon" />
            Services Offered
          </h2>
          <div class="services-grid">
            <div class="service-card">
              <div class="card-icon green">
                <i class="fas fa-user-graduate" />
              </div>
              <h3>Academic Counseling</h3>
              <p>Support for academic concerns, study habits, and time management strategies.</p>
            </div>
            <div class="service-card">
              <div class="card-icon yellow">
                <i class="fas fa-heart" />
              </div>
              <h3>Personal Counseling</h3>
              <p>Confidential support for personal issues, stress, anxiety, and emotional concerns.</p>
            </div>
            <div class="service-card">
              <div class="card-icon green">
                <i class="fas fa-briefcase" />
              </div>
              <h3>Career Guidance</h3>
              <p>Career exploration, aptitude assessment, and vocational planning assistance.</p>
            </div>
            <div class="service-card">
              <div class="card-icon yellow">
                <i class="fas fa-users" />
              </div>
              <h3>Group Sessions</h3>
              <p>Workshops and group activities focusing on personal development and life skills.</p>
            </div>
          </div>
        </section>

        <!-- Schedule -->
        <section class="content-section">
          <h2>
            <i class="fas fa-calendar-alt section-icon" />
            Office Hours
          </h2>
          <div class="schedule-card">
            <div class="schedule-row">
              <span class="day">Monday - Friday</span>
              <span class="time">8:00 AM - 5:00 PM</span>
            </div>
            <div class="schedule-row">
              <span class="day">Saturday</span>
              <span class="time">By Appointment Only</span>
            </div>
            <div class="schedule-row">
              <span class="day">Sunday</span>
              <span class="time">Closed</span>
            </div>
          </div>
        </section>

        <!-- Contact -->
        <section class="content-section">
          <h2>
            <i class="fas fa-phone section-icon" />
            Contact Information
          </h2>
          <div class="contact-info">
            <div class="contact-item">
              <i class="fas fa-map-marker-alt" />
              <span>Room 201, Student Services Building</span>
            </div>
            <div class="contact-item">
              <i class="fas fa-phone" />
              <span>(078) 123-4567 Local 201</span>
            </div>
            <div class="contact-item">
              <i class="fas fa-envelope" />
              <span>counseling@nc.edu.ph</span>
            </div>
          </div>
        </section>

        <!-- CTA -->
        <section class="cta-section">
          <h2>Need to Talk?</h2>
          <p>Book a confidential session with one of our counselors today.</p>
          <button
            class="cta-button"
            @click="bookAppointment"
          >
            <i class="fas fa-calendar-plus" />
            Schedule Appointment
          </button>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import ServicePageHeader from '@/components/landing/ServicePageHeader.vue'
import '@/assets/css/landing/pages/services.css'

export default {
  name: 'CounselingService',

  components: {
    ServicePageHeader
  },

  metaInfo: () => ({
    title: 'Guidance & Counseling'
  }),

  methods: {
    bookAppointment () {
      // TODO: Implement appointment booking
      this.$bvToast.toast('Appointment booking coming soon!', {
        title: 'Coming Soon',
        variant: 'info',
        solid: true
      })
    }
  }
}
</script>

<style scoped>
.service-page {
  min-height: 100vh;
  background: #f8fafc;
}

/* Header */
.service-header {
  position: relative;
  padding: 6rem 1.5rem 4rem;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  text-align: center;
  overflow: hidden;
}

.header-bg {
  position: absolute;
  inset: 0;
}

.bg-pattern {
  position: absolute;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.header-content {
  position: relative;
  z-index: 1;
  max-width: 700px;
  margin: 0 auto;
}

.back-link {
  position: absolute;
  top: -3rem;
  left: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50px;
  transition: all 0.2s;
}

.back-link:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.header-icon {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  margin: 0 auto 1.5rem;
}

.service-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 0.75rem;
}

.service-header p {
  font-size: 1.125rem;
  opacity: 0.9;
  margin: 0;
}

/* Content */
.service-content {
  padding: 3rem 0;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.content-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.content-section h2 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e3a2f;
  margin: 0 0 1rem;
}

.section-icon {
  color: #10b981;
}

.content-section p {
  color: #64748b;
  line-height: 1.7;
  margin: 0;
}

/* Services Grid */
.services-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

@media (min-width: 640px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.service-card {
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.card-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  margin-bottom: 1rem;
}

.card-icon.green {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.card-icon.yellow {
  background: rgba(251, 191, 36, 0.1);
  color: #f59e0b;
}

.service-card h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #1e3a2f;
  margin: 0 0 0.5rem;
}

.service-card p {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

/* Schedule */
.schedule-card {
  background: #f8fafc;
  border-radius: 12px;
  padding: 1rem;
}

.schedule-row {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.schedule-row:last-child {
  border-bottom: none;
}

.day {
  font-weight: 500;
  color: #1e3a2f;
}

.time {
  color: #10b981;
  font-weight: 500;
}

/* Contact */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #64748b;
}

.contact-item i {
  width: 20px;
  color: #10b981;
}

/* CTA */
.cta-section {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 16px;
  padding: 3rem 2rem;
  text-align: center;
  color: white;
}

.cta-section h2 {
  font-size: 1.5rem;
  margin: 0 0 0.5rem;
}

.cta-section p {
  opacity: 0.9;
  margin: 0 0 1.5rem;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 2rem;
  background: white;
  color: #059669;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}
</style>
